export class ApiError extends Error {
  readonly status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
  }
}

// Spring writes XSRF-TOKEN (or __Host-XSRF-TOKEN when secure cookies are on) and expects it echoed
// in X-XSRF-TOKEN on every state-changing request.
const CSRF_COOKIE = /(?:^|;\s*)(?:__Host-)?XSRF-TOKEN=([^;]*)/;

function csrfToken(): string | undefined {
  const value = CSRF_COOKIE.exec(document.cookie)?.[1];
  return value ? decodeURIComponent(value) : undefined;
}

export async function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  const method = (init.method ?? 'GET').toUpperCase();
  const headers = new Headers(init.headers);
  headers.set('Accept', 'application/json');
  if (method !== 'GET' && method !== 'HEAD') {
    const token = csrfToken();
    if (token) headers.set('X-XSRF-TOKEN', token);
  }

  const response = await fetch(path, { ...init, method, headers, credentials: 'same-origin' });
  if (!response.ok) {
    throw new ApiError(response.status, `${method} ${path} failed with ${response.status}`);
  }
  return response;
}
